import * as React from "react";
import Box from "@mui/material/Box";
import { Link } from "@mui/material";
import { Container } from "@material-ui/core";
import Divider from "@mui/material/Divider";

export default function () {

  return (
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      borderTop: '1px solid #E2E2E2',
      backgroundColor: '#fff',
      padding: '10px',
      zIndex: 900
    }}>
      <Container>
        <Box sx={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <Link href={I18N('Privacy policy url')} color="secondary" underline="none" sx={{
            fontSize: {
              xs: '7px',
              lg: 'inherit'
            },
            '&:hover': {
              color: '#C91113'
            }
          }}>{I18N("Privacy policy")}</Link>
          <Divider orientation="vertical" sx={{
            margin: '0 10px',
            height: '17px',
          }} />
          <Box sx={{
            color: '#3A415A',
            display: 'flex',
            fontSize: {
              xs: '10px',
              lg: 'inherit'
            }
          }}>
            <span>© Copyright</span>
            <Link href={I18N("Interplan Group url")} color="secondary" underline="none" sx={{
              fontWeight: 700,
              margin: '0 5px',
              fontSize: {
                xs: '10px',
                lg: 'inherit'
              },
              '&:hover': {
                color: '#C91113'
              }
            }}>{I18N("Interplan Group")}</Link>
            <span>{I18N("All Rights Reserved")}</span>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
